import { useEffect, useState, useReducer } from "react"
import fetchReducer from "./fetchReducer"
import axios from "axios"

const SERVER_URL = process.env.REACT_APP_SERVER_URL

function useFetchApi(initialUrl, initialData) {
  const [url, setUrl] = useState(initialUrl)
  const [state, dispatch] = useReducer(fetchReducer, {
    loading: true,
    error: false,
    data: initialData
  })

  useEffect(() => {
    let didCancel = false
    const fetchData = async () => {
      dispatch({ type: "FETCH_INIT" })
      try {
        const { data } = await axios.get(SERVER_URL + url)
        if (!didCancel) {
          console.log(data, " <<")
          dispatch({ type: "FETCH_SUCCESS", payload: data })
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({ type: "FETCH_FAILURE" })
        }
        console.log(error)
      }
    }

    fetchData()

    return () => {
      didCancel = true
    }
  }, [url])

  return [state, setUrl]
}

export default useFetchApi
